/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updated_OnInputs */



/**
* | output |
* | --- |
* | "Updated On" |
*
* @param {Updated_OnInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const updated_on = /** @type {((inputs?: Updated_OnInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updated_OnInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mis à jour le")
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktualisiert am")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiornato il")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обновлено")
	if (locale === "es") return /** @type {LocalizedString} */ ("Actualizado el")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更新于")
	if (locale === "ja") return /** @type {LocalizedString} */ ("更新日")
	if (locale === "hi") return /** @type {LocalizedString} */ ("को अपडेट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atualizado em")
	return /** @type {LocalizedString} */ ("Updated On")
});